import React from 'react'

import useThemeSettings from 'customizer/theme/useThemeSettings'
import CommonPrice from 'themes/common/components/Price'
import './ExtraPriceLabel.scss'

interface ExtraPriceProps {
  price?: string | number
  currency: string
  lang?: string
  country?: string
  extraClassNames?: string
  includeSign?: boolean
}

const ExtraPrice = ({ price, currency, lang, country, includeSign }: ExtraPriceProps) => {
  const priceStyle = useThemeSettings('price')

  if (!priceStyle.showExtraPrice || !price) return null

  return (
    <CommonPrice
      className="price"
      currency={currency}
      amount={price}
      lang={lang}
      country={country}
      includeSign={includeSign}
    />
  )
}

export default ExtraPrice
